import { useCustomer } from '../contexts/customer-context';
import axios from 'axios';

export const logout = async () => {
  try {
    // Get the token from localStorage
    const token = localStorage.getItem('token');

    if (token) {
      // Call the logout endpoint
      await axios.post('http://localhost:3000/auth/logout', null, {
        headers: {
          'x-auth-token': token
        }
      });
    }

    // Clear the auth token from localStorage
    localStorage.removeItem('token');
    
    // Clear any other session-related data
    localStorage.removeItem('customerId');
    
    // Clear session storage
    sessionStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

  } catch (error) {
    console.error('Error during logout:', error);
    // Even if the server call fails, we still want to clear local data
    localStorage.clear();
    sessionStorage.clear();
  }
};